export const pass = (): void => {};

export const seq =
    (...funcs: Array<(() => void) | undefined>) =>
    (): void => {
        funcs.forEach(func => func?.());
    };

